import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    DateField,
    CardActions,
    useListContext
} from 'react-admin';
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Filter from './Filter';
import UIButton from "@material-ui/core/Button";

const handleExcelClick = () => {
    let afterInput = document.getElementById('createdAt[after]');
    let beforeInput = document.getElementById('createdAt[before]');

    let after = afterInput ? afterInput.value : '';
    let before = beforeInput ? beforeInput.value : '';

    window.location = process.env.REACT_APP_BASE_ENTRYPOINT + '/unprocessed_prescription/report/xlsx?'
        + '&from=' + after
        + '&to=' + before
        + '&token=' + localStorage.getItem('session');
}

const UnprocessedPrescriptionActions = ({
                                       bulkActions,
                                       basePath,
                                       currentSort,
                                       displayedFilters,
                                       exporter,
                                       filters,
                                       filterValues,
                                       onUnselectItems,
                                       resource,
                                       selectedIds,
                                       showFilter,
                                       total
                                   }) => (
    <CardActions>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        })}
        <div>
            <Box component="span" mr={1} ml={2}>
                <UIButton variant="outlined" color="primary" onClick={handleExcelClick}>
                    Excel
                </UIButton>
            </Box>
        </div>
    </CardActions>
);

const Empty = () => {
    const {basePath} = useListContext();
    return (
        <Box textAlign="center" m={1}>
            <Typography variant="h4" paragraph>
                Необроблені рецепти - відсутні
            </Typography>
        </Box>
    );
};

export const UnprocessedPrescriptionList = (props) => (
    <List {...props}
          filters={<Filter />}
          empty={<Empty />}
          bulkActionButtons={false}
          className="list-styles"
          perPage={25}
          title="Необроблені рецепти"
          actions={<UnprocessedPrescriptionActions/>}
    >
        <Datagrid>
            <TextField sortable={false} label="Номер" source="number" />
            <TextField sortable={false} label="Мед. програма" source="medicalProgramName" />
            <DateField sortable={false} label="Дата" source="createdAt" locales={'ru'}/>
        </Datagrid>
    </List>
);

export default UnprocessedPrescriptionList;
